import { render, staticRenderFns } from "./ModalBoxes.vue?vue&type=template&id=572483e4&lang=html&"
import script from "./ModalBoxes.vue?vue&type=script&lang=js&"
export * from "./ModalBoxes.vue?vue&type=script&lang=js&"
import style0 from "./ModalBoxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports